// Firebase configuration Details
const firebaseConfig = {
  apiKey: "AIzaSyCUA-7D1Bh_41h-epOqcTz2n0uTTfpxqXA",
  authDomain: "fir-auth-c7eab.firebaseapp.com",
  projectId: "fir-auth-c7eab",
  storageBucket: "fir-auth-c7eab.appspot.com",
  messagingSenderId: "595867006169",
  appId: "1:595867006169:web:4b3151156fe10f0c42bac8"
};

export default firebaseConfig;